import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function Preise() {
  return (
    <div data-testid="page-preise">
      <section className="border-b border-[#E3DECE]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-7">
            <p className="text-xs uppercase tracking-[0.25em] font-semibold text-[#BA6D52]">Preise &amp; Konditionen</p>
            <h1 className="font-serif text-4xl sm:text-5xl md:text-6xl font-light tracking-tighter mt-6">
              Individuelle Angebote.
            </h1>
            <p className="text-[#757067] font-light text-lg mt-8 max-w-2xl">
              Faire Konditionen — gestaltbar nach Umfang, Regelmäßigkeit und Anlass.
              Sprechen Sie mich unverbindlich an, wir finden gemeinsam einen Weg,
              der für beide Seiten passt.
            </p>
          </div>
          <div className="lg:col-span-5">
            <div className="relative w-full aspect-[4/3] overflow-hidden border border-[#E3DECE]">
              <img
                src="https://images.unsplash.com/photo-1559339352-11d035aa65de?w=1600&q=80&auto=format&fit=crop"
                alt="Hochwertige Tellerkultur"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Was ist im Stundensatz enthalten — Reframing VOR den Zahlen */}
      <section className="border-b border-[#E3DECE] bg-[#FAF5F1]/40">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20">
          <p className="text-xs uppercase tracking-[0.25em] text-[#BA6D52] font-semibold">Was in meinem Stundensatz enthalten ist</p>
          <h2 className="font-serif text-3xl sm:text-4xl font-light tracking-tight mt-4 max-w-3xl">
            Kein Angestellter, kein Aufwand — nur die Stunden, die ich für Sie arbeite.
          </h2>
          <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              {
                t: "Ausgebildeter Koch",
                d: "Jahrelange Erfahrung in gehobener Gastronomie und Sterneküche.",
              },
              {
                t: "Volle Verlässlichkeit",
                d: "Kein Krankenausfall zu Ihren Lasten, kein Verwaltungsaufwand, keine Sozialabgaben, keine Urlaubsansprüche.",
              },
              {
                t: "Vorbereitung inklusive",
                d: "Menü-Planung, Absprachen und mein eigener Messerkoffer sind selbstverständlich dabei — nicht gesondert berechnet.",
              },
            ].map((item) => (
              <div key={item.t} className="border-t border-[#E3DECE] pt-4">
                <p className="text-xs uppercase tracking-[0.2em] text-[#BA6D52]">{item.t}</p>
                <p className="text-[#2C2A26] font-light leading-relaxed mt-2 text-sm">{item.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="border-b border-[#E3DECE]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28">
          <div className="mb-10 md:mb-14 max-w-3xl">
            <p className="text-xs uppercase tracking-[0.25em] text-[#BA6D52] font-semibold">Ausgangspunkte — nicht Fixpreise</p>
            <h2 className="font-serif text-3xl sm:text-4xl font-light tracking-tight mt-4">
              Meine Sätze sind ein Rahmen, kein Preisschild.
            </h2>
            <p className="text-[#757067] font-light leading-relaxed mt-5">
              Die folgenden Beträge gelten als Ausgangswerte für einmalige Einsätze. Bei
              mehreren Tagen, festen Aushilfe-Rhythmen oder regelmäßiger Zusammenarbeit
              passe ich die Konditionen gerne an. Reden Sie mich einfach in der Anfrage
              darauf an — <b>alles ist individuell verhandelbar</b>.
            </p>
            <p className="text-[#757067] font-light leading-relaxed mt-4 text-sm">
              Alle hier genannten Beträge sind <b>Nettopreise für gewerbliche Auftraggeber</b>
              (zzgl. der gesetzlichen Umsatzsteuer). Als <b>Privatkunde</b> erhalten Sie stattdessen
              einen <b>Festpreis als Endpreis einschließlich Umsatzsteuer</b> — ohne Abrechnung
              nach Stunden. Ihr persönliches Angebot finden Sie unter{" "}
              <a href="/privatkoch" className="underline hover:text-[#BA6D52]">Privatkoch</a>.
            </p>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
            <div className="lg:col-span-7 border-t border-[#E3DECE]">
              {[
                { label: "Werktag (Mo–Fr)", value: "ab 49 € netto / h", note: "… bei einmaligem Tageseinsatz — individuell anpassbar" },
                { label: "Sonn- & Feiertag", value: "ab 59 € netto / h", note: "… für Wochenend- oder Feiertagseinsätze — anpassbar" },
                { label: "Ab 3 Tagen", value: "reduzierter Satz", note: "… bei mehrtägigen Einsätzen — konkrete Zahl im Angebot" },
                { label: "Feste Kooperation", value: "deutlich günstiger", note: "… bei planbarer Zusammenarbeit — individuelles Angebot" },
                { label: "Mindestbuchung", value: "4 Stunden", note: "pro Einsatz" },
                { label: "Spontanbuchung", value: "+ 10 %", note: "bei Buchung innerhalb 24 h — verhandelbar" },
                { label: "Abrechnung", value: "Rechnung", note: "Zahlungsziel 7 Tage netto" },
              ].map((row) => (
                <div
                  key={row.label}
                  className="border-b border-[#E3DECE] py-8 grid grid-cols-12 gap-6 items-baseline"
                >
                  <div className="col-span-12 sm:col-span-4">
                    <p className="text-xs uppercase tracking-[0.2em] text-[#BA6D52]">
                      {row.label}
                    </p>
                  </div>
                  <div className="col-span-12 sm:col-span-5">
                    <p className="font-serif text-2xl sm:text-3xl font-light text-[#2C2A26]">
                      {row.value}
                    </p>
                  </div>
                  <div className="col-span-12 sm:col-span-3">
                    <p className="text-sm text-[#757067] font-light">{row.note}</p>
                  </div>
                </div>
              ))}
            </div>

            <aside className="lg:col-span-5 bg-[#F2EFE9] border border-[#E3DECE] p-10">
              <p className="text-xs uppercase tracking-[0.25em] text-[#BA6D52]">Zum Vergleich</p>
              <p className="font-serif text-3xl font-light mt-4">Was der Markt kostet.</p>
              <div className="mt-6 space-y-4 text-sm">
                <div className="border-b border-[#E3DECE] pb-3">
                  <p className="text-[#757067]">Aushilfskoch über Zeitarbeit</p>
                  <p className="font-serif text-xl mt-1">55 – 70 € netto / h</p>
                  <p className="text-xs text-[#757067] mt-1">zzgl. Vermittlungsgebühr, meist mit Bindung an die Agentur.</p>
                </div>
                <div className="border-b border-[#E3DECE] pb-3">
                  <p className="text-[#757067]">Vermittelter Springerkoch</p>
                  <p className="font-serif text-xl mt-1">60 – 80 € netto / h</p>
                  <p className="text-xs text-[#757067] mt-1">bei kurzfristigem Bedarf oft die einzige Alternative.</p>
                </div>
                <div className="pt-2">
                  <p className="text-[#BA6D52] uppercase tracking-[0.2em] text-xs font-semibold">Bei mir direkt</p>
                  <p className="font-serif text-2xl mt-1 text-[#2C2A26]">ab 49 € netto / h</p>
                  <p className="text-xs text-[#757067] mt-1">Keine Vermittlungsgebühr, direkte Absprache, verhandelbar bei Umfang.</p>
                </div>
              </div>
              <p className="mt-6 text-xs text-[#757067] font-light leading-relaxed border-t border-[#E3DECE] pt-4">
                Marktpreise sind Durchschnittswerte aus der Gastronomie-Praxis und dienen der Orientierung.
              </p>
            </aside>
          </div>

          <div
            data-testid="langzeit-hinweis"
            className="mt-12 lg:mt-16 border border-[#BA6D52]/30 bg-[#FAF5F1] p-8 md:p-10 flex flex-col md:flex-row gap-6 md:gap-10 md:items-center"
          >
            <div className="shrink-0">
              <p className="text-xs uppercase tracking-[0.25em] text-[#BA6D52]">Preise sind ein Ausgangspunkt</p>
              <p className="font-serif text-2xl sm:text-3xl font-light text-[#2C2A26] mt-3">
                Reden Sie mit mir — wir finden eine Lösung.
              </p>
            </div>
            <p className="text-[#2C2A26] font-light leading-relaxed text-base md:text-[15px] md:border-l md:border-[#E3DECE] md:pl-10">
              Bei mehrtägigen Einsätzen, festen Aushilfe-Rhythmen oder regelmäßiger
              Zusammenarbeit gehen die Konditionen deutlich runter. Schreiben Sie mir
              einfach kurz worum es geht — ich melde mich innerhalb 24 Stunden mit
              einem persönlichen Angebot zurück, unverbindlich und ohne Verpflichtung.
            </p>
          </div>
        </div>
      </section>

      <section>
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28">
          <h2 className="font-serif text-3xl sm:text-4xl font-light tracking-tight">Häufige Fragen</h2>
          <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-10">
            {[
              {
                q: "Gilt der Stundensatz auch an Sonn- und Feiertagen?",
                a: "An Sonn- und gesetzlichen Feiertagen beträgt der Stundensatz 59 € netto.",
              },
              {
                q: "Was bedeutet Spontanbuchung?",
                a: "Bei Einsätzen, die weniger als 24 Stunden im Voraus angefragt werden, wird ein Zuschlag von 10 % auf den Stundensatz erhoben.",
              },
              {
                q: "Was passiert bei kurzfristigem Ausfall?",
                a: "Ich versuche jederzeit eine verbindliche Zusage zu halten. Bei Krankheit informiere ich umgehend.",
              },
              {
                q: "Gibt es einen Mindesteinsatz?",
                a: "Ja, der Mindesteinsatz beträgt 4 Stunden pro Einsatztag.",
              },
              {
                q: "Wie wird abgerechnet?",
                a: "Nach erfolgtem Einsatz per Rechnung mit Zahlungsziel von 7 Tagen.",
              },
            ].map((f) => (
              <div key={f.q} className="border-t border-[#E3DECE] pt-6">
                <h3 className="font-serif text-xl font-medium">{f.q}</h3>
                <p className="text-[#757067] font-light mt-3 leading-relaxed">{f.a}</p>
              </div>
            ))}
          </div>

          <div className="mt-16">
            <Link
              to="/anfrage"
              data-testid="preise-cta-anfrage"
              className="inline-flex items-center gap-3 bg-[#BA6D52] text-white hover:bg-[#9E5841] px-8 py-5 text-xs uppercase tracking-[0.2em] transition-colors"
            >
              Jetzt Anfrage stellen <ArrowRight size={16} />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
